import { z } from 'zod';
import { requireFields, yesNoRequired } from '@utils/form-schema';

export const assessKidneyStonesSchema = z
    .object({
        hasHadKidneyStones: yesNoRequired,
        kidneyStoneEpisodes: z.string(),
        kidneyStoneRemissionStatus: z.string(),
        kidneyStoneTreatment: z.string(),
    })
    .superRefine((data, ctx) => {
        if (data.hasHadKidneyStones === '1') {
            requireFields(ctx, data, 'kidneyStoneEpisodes', 'kidneyStoneRemissionStatus');
        }
    });
